/**
 * 查询群组所有联系人
 **/

import React from 'react';
import { Button, Dropdown, Form, Icon, Tooltip, message, Popconfirm, Select, Radio, Input, Row, Col } from 'antd';
import { Link } from 'react-router';
import { fetchSubAccountEventsApplys } from "../../redux/actions/subAccount";
import CKDataTablePage2 from '../../components/CKDataTablePage2';
import { updateSubAccountEventsApply, deleteSubAccountEventsApply } from '../../services/subAccounts'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { antdTableColumnsMerge } from "../../utils/index";
import Holder from "../../components/Holder";
import QRCode from "../../components/qr-code/QRCode";


const Option = Select.Option;
const Search = Input.Search;
const groupsStyle = {
    display: '-webkit-flex',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',

}


class SubAccountEvtApplyList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchParams: Object.assign({}, {
                status: 'LOADING',
                isSub:props.isSub
            }, this.props.subAccountEventsApplys.searchParams),
            selectedRowKeys: [],
            selectedRecords: [],
            columns: antdTableColumnsMerge([
                {
                    title: <div>
                        <span>申请人 </span>
                    </div>,
                    dataIndex: 'subUserName',
                    width: 140,
                },

                { title: '活动名', width: 140, dataIndex: 'name',render:(text,record,index)=>(
                    <Tooltip title={text}>
                        {text}
                    </Tooltip>
                ) },
                { title: '申请时间', dataIndex: 'createTime', },

                {
                    title: '操作',
                    key: 'operation',
                    fixed: 'right',
                    width: 120,
                    render: (text, record, index) => (
                        !props.isSub && <span>
                            {
                                record.status == 'LOADING' &&
                                (
                                    <span>
                                        <Popconfirm title={<span>您确定要通过该活动<span className="mdc-text-red">{record.name}</span>的创建申请吗?</span>}
                                            placement="leftBottom"
                                            onConfirm={(e) => {
                                                updateSubAccountEventsApply({ id: record.id ,status:'CREATED' }).then(res => {
                                                    if (res.code == 200) {
                                                        message.success('操作成功!');
                                                        this.fetchFilterTableData();
                                                    } else {
                                                        message.error(res.msg,6);
                                                    }
                                                }).catch(err => {
                                                    message.warn("访问异常");
                                                })
                                            }}
                                            okText="确定"
                                            cancelText="放弃">
                                            <a href="#">通过</a>
                                        </Popconfirm>
                                        <span className="ant-divider" />
                                        <Popconfirm title={<span>您确定要拒绝该活动<span className="mdc-text-red">{record.name}</span>的创建申请吗?</span>}
                                            placement="leftBottom"
                                            onConfirm={(e) => {
                                                updateSubAccountEventsApply({ id: record.id,status:'CANCEL' }).then(res => {
                                                    if (res.code == 200) {
                                                        message.success('操作成功!');
                                                        this.fetchFilterTableData();
                                                    } else {
                                                        message.error(res.msg,6);
                                                    }
                                                }).catch(err => {
                                                    message.warn("访问异常");
                                                })
                                            }}
                                            okText="确定"
                                            cancelText="放弃">
                                            <a href="#">拒绝</a>
                                        </Popconfirm>
                                        <span className="ant-divider" />
                                    </span>
                                )
                            }


                            <Popconfirm title={<span>您确定要删除 <span className="mdc-text-red">{record.name}</span>活动申请吗?</span>}
                                placement="leftBottom"
                                onConfirm={(e) => {
                                    deleteSubAccountEventsApply({ id: record.id }).then(res => {
                                        if (res.code == 200) {
                                            message.success('删除成功!');
                                            this.fetchFilterTableData();
                                        } else {
                                            message.error(res.msg,6);
                                        }
                                    }).catch(err => {
                                        message.warn("访问异常");
                                    })
                                }}
                                okText="删除"
                                cancelText="放弃">
                                <a href="#">删除</a>
                            </Popconfirm>
                        </span>
                    ),
                },

            ], (this.props.subAccountEventsApplys.extra && this.props.subAccountEventsApplys.extra.columns) ? this.props.subAccountEventsApplys.extra.columns : [])

        }
    }
    componentDidMount() {
    }
    componentWillReceiveProps(nextProps) {

    }

    handleTableRowsSelectChange = (selectedRowKeys, selectedRecords) => {
        this.setState({ selectedRowKeys, selectedRecords });
    }


    fetchData = (params, pagination = this.props.pagination, sort = this.props.sort) => {
        this.props.fetchSubAccountEventsApplys(Object.assign({}, params), pagination, sort, { columns: this.state.columns });
    }

    fetchFilterTableData() {
        this.refs.GroupsCkDataTablePage.fetchTableData();

    }

    searchParamsChange(propName, val, invokingFetchFilterTableData = true) {
        const searchParams = { ...this.state.searchParams };
        searchParams[propName] = val;
        this.setState({
            searchParams: searchParams,
        }, () => {
            if (invokingFetchFilterTableData) {
                this.fetchFilterTableData();
            }
        });
    }

    handleTableColumnsChange = (columns) => {
        this.setState({
            columns: columns
        })
    }


    render() {

        const ckDataTableToolbarLeft =
            <div>
                <Radio.Group size="large"
                    value={this.state.searchParams.status}
                    onChange={(e) => {
                        this.searchParamsChange("status", e.target.value);
                    }}>
                    {
                        Object.values(this.props.cmEnums.data.CmEventApplyStatus).map((item, index) => {
                            return <Radio.Button value={item.enumName.toString()} key={`event-apply-${index}`}>{item.enumDesc}</Radio.Button >
                        })
                    }
                </Radio.Group>
            </div>
        const ckDataTablerRowSelectionActions =
            <div>


            </div>



        return (
            <CKDataTablePage2
                ref='GroupsCkDataTablePage'
                comp={this}
                className={'subevtapplystyle'}
                // tableScroll={{x: 1400, y: 'calc(100vh - 292px)'}}
                tableRowSelectionActions={ckDataTablerRowSelectionActions}
                toolbarLeft={ckDataTableToolbarLeft}
                tableRowKey={record => record.id}
                tableColumns={this.state.columns}
                tableSelectedRowKeys={this.state.selectedRowKeys}
                tableSelectedRowKeysChange={this.handleTableRowsSelectChange}
                tableDataSource={this.props.subAccountEventsApplys}
                tableDataSourceFetch={this.fetchData}
                tableDataSourceFetchSearchParams={this.state.searchParams}
                tableColumnsChange={this.handleTableColumnsChange}
                reloadOnMount={this.props.lastLocation == null || this.props.lastLocation.action != "POP"}
                expandedRowRender={record => (
                    <Row style={{ fontSize: 12, paddingRight: 100 }}>
                        <Col span={24}>
                            <img style={{width:90,height:60}} src={record.banner ? record.banner : 'https://img.qdj8.cn/event-default.png'} alt=""/>
                        </Col>
                        <Col span={12}>活动开始时间：<span style={{ color: '#959595' }}>{record.beginTime}</span></Col>
                        <Col span={12}>活动截止时间：<span style={{ color: '#959595' }}>{record.endTime}</span></Col>
                        <Col span={12}>报名开始时间：<span style={{ color: '#959595' }}>{record.registerBeginTime}</span></Col>
                        <Col span={12}>报名截止时间：<span style={{ color: '#959595' }}>{record.registerEndTime}</span></Col>
                        <Col span={12}>预计人数：<span style={{ color: '#959595' }}>{record.expectPeopleCount}</span></Col>
                        <Col span={12}>签到积(学）分：<span style={{ color: '#959595' }}>{record.courseTime}</span></Col>
                        <Col span={12}>联系电话：<span style={{ color: '#959595' }}>{record.contactPhone}</span></Col>
                        <Col span={12}>活动地址：<span style={{ color: '#959595' }}>{record.address}</span></Col>
                        <Col span={24}>活动详情：<span style={{ color: '#959595' }}>{record.summary}</span></Col>
                    </Row>
                )}
                tableRowSelectDisabled={false}
                tableColumnsControlDisable={true}>


            </CKDataTablePage2>
        )
    }
}
SubAccountEvtApplyList.defaultProps = {
    isSub:false
}

const mapStateToPorps = state => {
    const subAccountEventsApplys = state.subAccountEventsApplys;
    const cmEnums = state.cmEnums;

    return { subAccountEventsApplys, cmEnums };
};
const mapDispatchToProps = dispatch => ({
    fetchSubAccountEventsApplys: bindActionCreators(fetchSubAccountEventsApplys, dispatch),
});


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(SubAccountEvtApplyList));


// WEBPACK FOOTER //
// ./src/containers/subaccount/SubAccountEvtApplyList.jsx